import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import styled from "styled-components";
import UserService from "services/UserService";
import { getAccountMeters } from "services/ConfigServices";
import UploadMetersDialog from "./Meters/UploadMetersDialog";
import UploadContractDialog from "./Contracts/UploadContractDialog";

const UploadButton = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {

    getStructureData();
  }, [isRefetched, JSON.stringify(action.parameters?.impact?.meters)]);

  const UploadMeters = ({ onUpload }) => (
    <UploadButton type="button" onClick={onUpload}>
      <UploadMetersDialog
        onClick={onUpload}
        refetch={refreshTable}
        //setLoading={setLoading}
      />
    </UploadButton>
  );

  const EditContracts = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        <UploadContractDialog
          onClick={onUpload}
          refetch={refreshTable}
          disabled={!action.parameters?.impact?.meters?.length ?? false}
        />
      </UploadButton>
    </>
  );

  const getStructureData = async () => {
    let meters = action.parameters?.impact?.meters || [];

    setStructureData(meters);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <TableName></TableName>
        {actionplanadmin && action?.parameters?.impact?.energy && (
          <>
            <UploadMeters key="UploadMeters" />
            <EditContracts key="EditContracts" />
          </>
        )}
      </>
    );
  }, [
    action?.parameters?.impact?.energy,
    action.parameters?.impact?.meters?.length,
  ]);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      //title: headerComponentMemo,
      subHeaderComponent: subHeaderComponentMemo,
    },
    refreshTable,
  };
}
